import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfirmDialogService, ConfirmDialogOptions } from './confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  standalone: false,
  template: `
    @if (visible) {
      <div class="dialog-backdrop" (click)="onReject()">
        <div class="dialog-panel" style="width:420px;" (click)="$event.stopPropagation()">
          <div class="dialog-header">
            <span>{{ options?.header }}</span>
          </div>
          <div class="dialog-body">
            <p style="margin:0;">{{ options?.message }}</p>
          </div>
          <div class="dialog-footer">
            <button class="btn btn-secondary" (click)="onReject()">{{ options?.rejectLabel || 'Nein' }}</button>
            <button class="btn btn-primary" (click)="onAccept()">{{ options?.acceptLabel || 'Ja' }}</button>
          </div>
        </div>
      </div>
    }
  `
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  visible = false;
  options: ConfirmDialogOptions | null = null;
  private resolveFn: ((value: boolean) => void) | null = null;
  private sub!: Subscription;

  constructor(private confirmDialogService: ConfirmDialogService) {}

  ngOnInit(): void {
    this.sub = this.confirmDialogService.confirm$.subscribe((data) => {
      this.options = data;
      this.resolveFn = data.resolve;
      this.visible = true;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  onAccept(): void {
    this.visible = false;
    this.resolveFn?.(true);
    this.resolveFn = null;
  }

  onReject(): void {
    this.visible = false;
    this.resolveFn?.(false);
    this.resolveFn = null;
  }
}
